/// <reference types="vite-plugin-svgr/client" />
import { Icon as GSIcon } from "@gluestack-ui/themed";

import { IIcon } from "./types";
import { IconMap } from "./constants";
import { SvgIcon } from "./SvgIcon/SvgIcon";

export const Icon = ({
  name,
  color,
  variant = "regular",
  zIndex = 0,
  strokeWidth = 1,
  ...rest
}: IIcon) => {
  const iconConfig = IconMap[name];

  if (!iconConfig) return null;

  const { scale = 1, regularSvg, solidSvg } = iconConfig;
  const svg = variant === "regular" ? regularSvg : solidSvg;

  return (
    <GSIcon
      zIndex={zIndex}
      style={{
        transform: `scale(${scale})`,
        zIndex,
        pointerEvents: "none"
      }}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      as={(props: any) => {
        return (
          <SvgIcon
            svg={svg}
            size={props.size}
            fill={color}
            strokeWidth={strokeWidth}
          />
        );
      }}
      {...rest}
    />
  );
};
